import { Injectable, Signal } from '@angular/core';
import { IBeneficiariesData, IBeneficiariesModel, IBeneficiaryDetails } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { BeneficiariesActions, BeneficiariesSelectors, IBeneficiariesState, IBeneficiaryFormMode } from '../store';

@Injectable({
  providedIn: 'root'
})
export class BeneficiariesStore extends StateAccessService<IBeneficiariesState> {
  readonly state$: Observable<IBeneficiariesState>;

  readonly data$$: Signal<IBeneficiariesData>;
  readonly model$$: Signal<IBeneficiariesModel>;

  readonly addedBeneficiaries$$: Signal<IBeneficiaryDetails[]>;
  readonly selectedBeneficiary$$: Signal<IBeneficiaryDetails>;
  readonly beneficiaryFormMode$$: Signal<IBeneficiaryFormMode>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(BeneficiariesSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(BeneficiariesSelectors.data);
    this.addedBeneficiaries$$ = this.stateFacade.selectSignal$(BeneficiariesSelectors.addedBeneficiaries);
    this.selectedBeneficiary$$ = this.stateFacade.selectSignal$(BeneficiariesSelectors.selectedBeneficiary);
    this.beneficiaryFormMode$$ = this.stateFacade.selectSignal$(BeneficiariesSelectors.beneficiaryFormMode);
  }

  dispatchBeneficiariesReset() {
    this.stateFacade.dispatch(BeneficiariesActions.reset());
  }
  dispatchAddBeneficiary(beneficiary: IBeneficiaryDetails) {
    this.stateFacade.dispatch(BeneficiariesActions.addBeneficiary({ beneficiary }));
  }
  dispatchRemoveBeneficiary(beneficiary: IBeneficiaryDetails) {
    this.stateFacade.dispatch(BeneficiariesActions.removeBeneficiary({ beneficiary }));
  }
  dispatchRemoveAllBeneficiaries() {
    this.stateFacade.dispatch(BeneficiariesActions.removeAllBeneficiaries());
  }
  dispatchUpdateBeneficiaryFormMode(beneficiaryFormMode: IBeneficiaryFormMode) {
    this.stateFacade.dispatch(BeneficiariesActions.updateBeneficiaryFormMode({ beneficiaryFormMode }));
  }
  dispatchUpdateBeneficiary(beneficiary: IBeneficiaryDetails) {
    this.stateFacade.dispatch(BeneficiariesActions.updateBeneficiary({ beneficiary }));
  }
  dispatchBeneficiariesLoad() {
    this.stateFacade.dispatch(BeneficiariesActions.load());
  }
  dispatchBeneficiariesLoadSuccess({ model, data }: { model: IBeneficiariesModel; data: IBeneficiariesData }) {
    this.stateFacade.dispatch(BeneficiariesActions.loadSuccess({ model, data }));
  }
  dispatchBeneficiariesSubmitSuccess({ model, data }: { model: IBeneficiariesModel; data: IBeneficiariesData }) {
    this.stateFacade.dispatch(BeneficiariesActions.submitSuccess({ model, data }));
  }
  dispatchBeneficiariesSubmit() {
    this.stateFacade.dispatch(BeneficiariesActions.submit());
  }
  dispatchSelectBeneficiary(beneficiary: IBeneficiaryDetails) {
    this.stateFacade.dispatch(BeneficiariesActions.selectBeneficiary({ beneficiary }));
  }
  dispatchResetSelectedBeneficiary() {
    this.stateFacade.dispatch(BeneficiariesActions.resetBeneficiary());
  }
}
